import { Box } from '@mui/material';
import React from 'react';
import Loading from '../components/Loading';
import { FormModalBodyProps } from './formUtils';

export default function FormModalBody({ modalBodySx, isLoading, children }: FormModalBodyProps) {
    return (
        <Box
            className="form-modal-body"
            sx={{
                overflowY: 'auto',
                overflowX: 'hidden',
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                flexGrow: 2,
                ...modalBodySx
            }}
        >
            {isLoading ? <Loading /> : typeof children === 'function' ? children() : children}
        </Box>
    );
}
